module.exports = __webpack_public_path__ + "img/avatar.f7c60ac8.svg";